import React, { useEffect, useState, useCallback, useMemo } from "react";
import { getAnonymousChatHistory, getChatHistory, getCustomerChat, getIdentifiedChatHistory, getInquiryChatHistory, getNewChatHistory, InsertMandetoryQue, filterChatHistory } from "../../Services/chatbot";
import "../../assets/chatbotconfig.css";
import QnAModal from "../QnAModal/index";
import { toast } from "react-toastify";
import teachicon from "../../assets/teachme.png";
import viewdetailicon from "../../assets/viewdetail.png";
import { Tooltip, OverlayTrigger, Modal, Button, Form } from "../../../evo/bootstrap";
import AllChatHistory from "../ChatHIstoryTab/AllChatHistory/index";
import DateRangeSelector from "../DateRangeFilter/index";
import { format } from "date-fns";

const NewChatHistory = ({ propertyId, setConfirmModal, setIsDirty, isDirty, onLoaded }: any) => {
    const [activeInnerTab, setActiveInnerTab] = useState("allchat");
    const [loading, setLoading] = useState(false);
    const [chatData, setChatData] = useState<any>([]);
    const [all_last_key, setAll_last_key] = useState("")
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [limit] = useState(50);
    // Store pagination keys history for backward navigation
    const [paginationKeys, setPaginationKeys] = useState<any>([]); // Array of keys: [null, key1, key2, ...]
    // Display control: show 10 initially, can expand to 50
    const [displayCount, setDisplayCount] = useState(10);
    const INITIAL_DISPLAY = 10;
    // Track if initial load has records (to decide whether to show pagination)
    const [hasInitialRecords, setHasInitialRecords] = useState(false);
    // Refresh key to reset AllChatHistory component state
    const [refreshKey, setRefreshKey] = useState(0);

    // Helper function to get default last week date range
    const getDefaultDateRange = () => {
        const today = new Date();
        const lastWeek = new Date(today);
        lastWeek.setDate(lastWeek.getDate() - 7);
        return {
            startDate: lastWeek,
            endDate: today,
            key: 'selection'
        };
    };

    // Helper function to get default filters with last week dates
    const getDefaultFilters = () => {
        const today = new Date();
        const lastWeek = new Date(today);
        lastWeek.setDate(lastWeek.getDate() - 7);
        return {
            from_date: format(lastWeek, "yyyy-MM-dd"),
            to_date: format(today, "yyyy-MM-dd"),
            status: "",
            confidence: ""
        };
    };

    // Filter modal and filter state
    const [showFilterModal, setShowFilterModal] = useState(false);
    const [filteredTableData, setFilteredTableData] = useState<any>([]);
    const [showFilteredTable, setShowFilteredTable] = useState(false);
    const [filterLoading, setFilterLoading] = useState(false);
    const [dateRange, setDateRange] = useState<any>([getDefaultDateRange()]);
    const [tempFilters, setTempFilters] = useState(getDefaultFilters());
    const [isInitialFilterApplied, setIsInitialFilterApplied] = useState(false);
    const [newQuestionDraft, setNewQuestionDraft] = useState<any>({
        question: '', answer: '', intentID: '', order_id: '', propertyID: '', type: ''
    });
    const [showQnaModal, setShowQnaModal] = useState(false);
    const [qnaError, setQnaError] = useState("");
    const [modalLoading, setModalLoading] = useState(false);
    const [selectedChatItem, setSelectedChatItem] = useState<any>(null);
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [sortConfig, setSortConfig] = useState<any>({
        key: null,
        direction: 'asc'
    });
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(5);
    const [searchText, setSearchText] = useState("");
    const [debouncedSearchText, setDebouncedSearchText] = useState("");

    // Helper function to format time ago (e.g., "59m ago", "2h ago", "3d ago", "2 weeks ago", "3 months ago", "1 year ago")
    const formatTimeAgo = (dateStr) => {
        if (!dateStr) return "N/A";
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) return "Invalid date";

        const now = new Date();
        const diffMs = +now - +date;
        const diffMins = Math.floor(diffMs / 60000);
        const diffHours = Math.floor(diffMs / 3600000);
        const diffDays = Math.floor(diffMs / 86400000);

        if (diffMins < 60) {
            return `${diffMins}m ago`;
        } else if (diffHours < 24) {
            return `${diffHours}h ago`;
        }

        // For 1–6 days, keep showing in days
        if (diffDays < 7) {
            return `${diffDays}d ago`;
        }

        // For 1–4 weeks, show in weeks
        if (diffDays < 30) {
            const weeks = Math.floor(diffDays / 7);
            return `${weeks} week${weeks > 1 ? "s" : ""} ago`;
        }

        // For 1–11 months, show in months (approximate: 30 days per month)
        if (diffDays < 365) {
            const months = Math.floor(diffDays / 30);
            return `${months} month${months > 1 ? "s" : ""} ago`;
        }

        // 1+ years
        const years = Math.floor(diffDays / 365);
        return `${years} year${years > 1 ? "s" : ""} ago`;
    };

    const loadHistory = useCallback(async (last_key = "", options: any = {}) => {
        const { preserveOnEmpty = false } = options;
        setLoading(true);
        // Scroll to top when loading new page
        window.scrollTo({ top: 0, behavior: "smooth" });

        try {
            let res;
            if (activeInnerTab === "allchat") {
                res = await getNewChatHistory(limit, last_key);
            } else if (activeInnerTab === "identified") {
                res = await getIdentifiedChatHistory(limit, last_key);
            } else if (activeInnerTab === "anonymous") {
                res = await getAnonymousChatHistory(limit, last_key);
            } else if (activeInnerTab === "inquiry") {
                res = await getInquiryChatHistory(limit, last_key);
            }
            console.log("res data ", res.data)
            console.log("res.data?.last_evaluated_key ", res.data?.last_evaluated_key)
            const records = res.data?.records || [];
            const nextKey = res.data?.last_evaluated_key || null;

            // Always replace data, never append
            if (records.length > 0 || !preserveOnEmpty) {
                setChatData(records);
            }
            setAll_last_key(nextKey);
            setHasMore(!!nextKey);

            return { hasRecords: records.length > 0, nextKey }; // Return both hasRecords and nextKey
        } catch (error) {
            toast.error("Failed to load chat history");
            return { hasRecords: false, nextKey: null };
        } finally {
            setLoading(false);
        }
    }, [activeInnerTab, limit]);



    useEffect(() => {
        setChatData([]);
        setAll_last_key(null);
        setPage(1);
        setHasMore(true);
        setPaginationKeys([]); // Reset pagination history when tab changes
        setDisplayCount(INITIAL_DISPLAY); // Reset display count when tab changes
        setHasInitialRecords(false); // Reset initial records flag
        // Don't clear searchText - let user keep their search across tabs
        // setSearchText(""); // Commented out - search functionality disabled

        // Load initial data with retry logic
        const loadInitialData = async () => {
            // First attempt
            const { hasRecords, nextKey } = await loadHistory("");

            // If no records found on initial load, retry once
            if (!hasRecords && nextKey) {
                // Retry with the nextKey from first attempt
                const retryResult = await loadHistory(nextKey);

                // If retry also returns no records, set flag to hide pagination
                if (!retryResult.hasRecords) {
                    setHasInitialRecords(false);
                    setHasMore(false);
                } else {
                    setHasInitialRecords(true);
                }
            } else if (hasRecords) {
                // Records found on first attempt
                setHasInitialRecords(true);
            } else {
                // No records and no nextKey
                setHasInitialRecords(false);
                setHasMore(false);
            }
        };

        loadInitialData();
    }, [activeInnerTab, loadHistory]);

    // Reset display count when search text changes
    // useEffect(() => {
    //     setDisplayCount(INITIAL_DISPLAY);
    // }, [searchText]);

    const handleNextPage = async () => {
        if (!hasMore || !all_last_key || loading) return;

        const currentKey = all_last_key;

        // Load next page
        let { hasRecords, nextKey } = await loadHistory(currentKey, { preserveOnEmpty: true });

        // If no records found, retry once with the new last_key from the first attempt
        if (!hasRecords && nextKey) {
            const retryResult = await loadHistory(nextKey, { preserveOnEmpty: true });
            hasRecords = retryResult.hasRecords;
            nextKey = retryResult.nextKey;

            if (!hasRecords) {
                setHasMore(false);
            }
        } else if (!hasRecords && !nextKey) {
            // No records and no next key, disable next button
            setHasMore(false);
        }

        if (hasRecords) {
            setPaginationKeys((prev) => [...prev, currentKey]);
            setPage((prev) => {
                const newPage = prev + 1;
                // If we're moving to page 2, ensure pagination is shown
                if (newPage === 2) {
                    setHasInitialRecords(true);
                }
                return newPage;
            });
            setDisplayCount(INITIAL_DISPLAY); // Reset display count for new page
        }
    };

    const handlePreviousPage = async () => {
        if (page === 1) return;

        // Get the key for previous page from history
        // paginationKeys stores keys used to load each page:
        // - On page 2: paginationKeys = [key1] (key1 was used to load page 2)
        // - On page 3: paginationKeys = [key1, key2] (key2 was used to load page 3)
        // To go back: from page N to N-1, use paginationKeys[N-3] (or null if going to page 1)
        const previousKey = page === 2 ? null : paginationKeys[paginationKeys.length - 2];

        // Remove the last key from history (we're going back)
        setPaginationKeys((prev) => prev.slice(0, -1));

        // Load previous page
        await loadHistory(previousKey || "");
        setPage((prev) => prev - 1);
        setDisplayCount(INITIAL_DISPLAY); // Reset display count for new page
    };

    const handleLoadMore = () => {
        // Show all records
        setDisplayCount(chatData.length);
        // setDisplayCount(filteredChatData.length); // Commented out - search functionality disabled
    };

    const handleLoadLess = () => {
        setDisplayCount(INITIAL_DISPLAY); // Show only 10 records
    };




    const handleInnerTabChange = (newTab, e) => {
        if (e?.preventDefault) e.preventDefault();
        setActiveInnerTab(newTab);
    };

    const handleFilterSearch = async () => {
        // Reset all data first before applying new filters
        setFilteredTableData([]);
        setSearchText("");
        setDebouncedSearchText("");
        setCurrentPage(1);
        setPageSize(5);
        setSortConfig({ key: null, direction: 'asc' });
        setShowFilteredTable(false);

        setFilterLoading(true);
        try {
            // If dates are empty, use dateRange values
            const filtersToSend = { ...tempFilters };
            if (!filtersToSend.from_date || !filtersToSend.to_date) {
                // Ensure dateRange exists and has valid data
                if (!dateRange || !dateRange[0] || !dateRange[0].startDate || !dateRange[0].endDate) {
                    // Fallback to default date range if dateRange is invalid
                    const defaultRange = getDefaultDateRange();
                    filtersToSend.from_date = format(defaultRange.startDate, "yyyy-MM-dd");
                    filtersToSend.to_date = format(defaultRange.endDate, "yyyy-MM-dd");
                } else {
                    filtersToSend.from_date = format(dateRange[0].startDate, "yyyy-MM-dd");
                    filtersToSend.to_date = format(dateRange[0].endDate, "yyyy-MM-dd");
                }
            }

            // Validate date range (from_date should not be after to_date)
            if (filtersToSend.from_date && filtersToSend.to_date) {
                const fromDate = new Date(filtersToSend.from_date);
                const toDate = new Date(filtersToSend.to_date);
                if (fromDate > toDate) {
                    toast.error("Start date cannot be after end date");
                    setFilterLoading(false);
                    return;
                }
            }

            const res = await filterChatHistory(filtersToSend);

            // Validate API response structure
            if (!res || !res.data) {
                throw new Error("Invalid API response");
            }

            setFilteredTableData(res.data?.records || []);
            setShowFilteredTable(true);
        } catch (error) {
            console.error("Failed to fetch filtered chat history", error);
            const errorMessage = error.response?.data?.message || error.message || "Failed to fetch filtered data";
            toast.error(errorMessage);
            setFilteredTableData([]);
            setShowFilteredTable(false);
        } finally {
            setFilterLoading(false);
        }
    };

    const resetFilterModalState = () => {
        setShowFilteredTable(false);
        setFilteredTableData([]);
        setSearchText("");
        setDebouncedSearchText("");
        setCurrentPage(1);
        setPageSize(5);
        setSortConfig({ key: null, direction: 'asc' });
        const defaultFilters = getDefaultFilters();
        setTempFilters(defaultFilters);
        setDateRange([getDefaultDateRange()]);
        setIsInitialFilterApplied(false);
    };

    const handleResetFilters = async () => {
        // Calculate last 7 days (one week) and today dates
        const today = new Date();
        const lastWeek = new Date(today);
        lastWeek.setDate(lastWeek.getDate() - 7);

        // Format dates as yyyy-MM-dd
        const fromDate = format(lastWeek, "yyyy-MM-dd");
        const toDate = format(today, "yyyy-MM-dd");

        const resetFilters = {
            from_date: fromDate,
            to_date: toDate,
            status: "",
            confidence: ""
        };

        // Reset all filter inputs, search, pagination, and sort first
        setTempFilters(resetFilters);
        setDateRange([{
            startDate: lastWeek,
            endDate: today,
            key: "selection"
        }]);
        setFilteredTableData([]);
        setSearchText("");
        setDebouncedSearchText("");
        setCurrentPage(1);
        setPageSize(5);
        setSortConfig({ key: null, direction: 'asc' });
        setShowFilteredTable(false);

        setFilterLoading(true);

        try {
            // Call filter API with last 7 days to today date range
            const res = await filterChatHistory(resetFilters);

            // Validate API response structure
            if (!res || !res.data) {
                throw new Error("Invalid API response");
            }

            setFilteredTableData(res.data?.records || []);
            setShowFilteredTable(true);
        } catch (error) {
            console.error("Failed to reset filters", error);
            const errorMessage = error.response?.data?.message || error.message || "Failed to fetch filtered data";
            toast.error(errorMessage);
            setFilteredTableData([]);
            setShowFilteredTable(false);
        } finally {
            setFilterLoading(false);
        }
    };

    const handleRowClick = (item) => {
        setSelectedChatItem(item);
        setShowDetailModal(true);
    };

    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const getSortIcon = (key) => {
        if (sortConfig.key === key) {
            return sortConfig.direction === 'asc' ? '↑' : '↓';
        }
        return '↕';
    };

    // Debounce search text to avoid filtering on every keystroke
    useEffect(() => {
        const handle = setTimeout(() => {
            setDebouncedSearchText(searchText);
        }, 300);
        return () => clearTimeout(handle);
    }, [searchText]);

    // Reset to page 1 when search text changes
    useEffect(() => {
        setCurrentPage(1);
    }, [debouncedSearchText]);

    // Auto-apply default filter when modal opens
    useEffect(() => {
        if (showFilterModal && !isInitialFilterApplied) {
            // Apply default filter automatically when modal opens
            // Use setTimeout to ensure state updates are applied first
            const timer = setTimeout(() => {
                handleFilterSearch();
                setIsInitialFilterApplied(true);
            }, 0);
            return () => clearTimeout(timer);
        }
         
    }, [showFilterModal, isInitialFilterApplied]);

    // Filter and sort data (memoized for performance)
    const { sortedData, filteredData } = useMemo(() => {
        const searchLower = debouncedSearchText.toLowerCase().trim();

        const filtered = filteredTableData.filter(item => {
            if (!item.question?.trim() && !item.answer?.trim()) {
                return false;
            }
            if (searchLower) {
                const questionMatch = item.question?.toLowerCase().includes(searchLower);
                // Only search in question field, not answer
                if (!questionMatch) {
                    return false;
                }
            }
            return true;
        });

        const sorted = [...filtered].sort((a, b) => {
            if (!sortConfig.key) return 0;
            const valA = a[sortConfig.key] ?? '';
            const valB = b[sortConfig.key] ?? '';
            if (sortConfig.key === 'msg_time') {
                const dateA = new Date(valA);
                const dateB = new Date(valB);
                // Handle invalid dates
                if (isNaN(dateA.getTime()) && isNaN(dateB.getTime())) return 0;
                if (isNaN(dateA.getTime())) return 1; // Invalid dates go to end
                if (isNaN(dateB.getTime())) return -1;
                return sortConfig.direction === 'asc'
                    ? +dateA - +dateB
                    : +dateB - +dateA;
            }
            return sortConfig.direction === 'asc'
                ? valA.toString().localeCompare(valB.toString())
                : valB.toString().localeCompare(valA.toString());
        });

        return { sortedData: sorted, filteredData: filtered };
    }, [filteredTableData, debouncedSearchText, sortConfig]);

    // Pagination over filtered & sorted data for better performance
    const totalPages = Math.ceil(sortedData.length / pageSize) || 1;
    const indexOfLastRecord = currentPage * pageSize;
    const indexOfFirstRecord = indexOfLastRecord - pageSize;
    const currentRecords = sortedData.slice(indexOfFirstRecord, indexOfLastRecord);

    const handleAddFaq = (item) => {
        setNewQuestionDraft({
            question: item.question,
            answer: '',
            intentID: '',
            order_id: '',
            type: 'QnA'
        });
        setShowQnaModal(true);
    };

    const handleFAQSave = async () => {
        setModalLoading(true);
        const timestamp = new Date().toISOString().replace(/[-:.TZ]/g, "");
        const uniqueIntentID = `Q${timestamp}`;
        const orderId = Math.floor(Math.random() * 10000).toString();

        const payload = {
            ...newQuestionDraft,
            type: "QnA",
            intentID: uniqueIntentID,
            order_id: orderId
        };

        try {
            const res = await InsertMandetoryQue(payload);
            if (res.status === 200) {
                toast.success(res.data.message);
                setShowQnaModal(false);
                setModalLoading(false);
                setIsDirty(false);
                // Refresh filtered data if table is showing
                if (showFilteredTable) {
                    await handleFilterSearch();
                }
            } else {
                toast.error(res.data.message);
            }
        } catch (error) {
            if (error.status === 401) {
                toast.error("Access denied. Please verify using a valid link.");
            }
            console.error("Failed to save question:", error);
            toast.error("Error saving question.");
        } finally {
            setModalLoading(false);
        }
    };

    const formatCustomDate = (dateStr) => {
        const date = new Date(dateStr);
        const day = date.getDate();
        const month = date.toLocaleString('default', { month: 'long' });
        const year = date.getFullYear();
        const time = date.toLocaleTimeString();

        const getOrdinal = (n) => {
            if (n > 3 && n < 21) return 'th';
            switch (n % 10) {
                case 1: return 'st';
                case 2: return 'nd';
                case 3: return 'rd';
                default: return 'th';
            }
        };

        return `${day}${getOrdinal(day)} ${month}, ${year} ${time}`;
    };

    const truncateText = (text, maxLength = 25) => {
        if (!text) return '-';
        if (text.length <= maxLength) return text;
        return text.substring(0, maxLength) + '...';
    };

    return (
        <>
            {loading && (
                <div className="loaderOverlay zIndex-1023">
                    <div className="loading">
                        <div className="main-loader"></div>
                    </div>
                </div>
            )}

            {/* Search and Filter Bar */}
            <div className="mb-4">
                <div className="d-flex align-items-center justify-content-between flex-wrap">
                    {/* Search Bar - Commented out */}
                    {/*   <div className="search-wrapper new-chat-search-wrapper">
                         <input
                            type="text"
                            className="form-control px-3 py-2 rounded w-100 pe-5"
                            placeholder="Search by name, email, or chat content..."
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                        />
                        <i className="bi bi-search search-icon"></i> 
                    </div>*/}

                    {/* Filter Buttons */}
                    <div className="d-flex  align-items-center tabs">
                        <button
                            type="button"
                            className={`btn btn-sm ${activeInnerTab === "allchat" ? "btn-warning active text-white" : ""}`}
                            onClick={(e) => handleInnerTabChange("allchat", e)}
                        >
                            All
                        </button>
                        <button
                            type="button"
                            className={`btn btn-sm ${activeInnerTab === "identified" ? "btn-warning active text-white" : ""}`}
                            onClick={(e) => handleInnerTabChange("identified", e)}
                        >
                            Identified
                        </button>
                        <button
                            type="button"
                            className={`btn btn-sm ${activeInnerTab === "anonymous" ? "btn-warning active text-white" : ""}`}
                            onClick={(e) => handleInnerTabChange("anonymous", e)}
                        >
                            Anonymous
                        </button>
                        {/* <button
                            type="button"
                            className={`btn btn-sm ${activeInnerTab === "inquiry" ? "btn-warning active text-white" : ""}`}
                            onClick={(e) => handleInnerTabChange("inquiry", e)}
                        >
                            Inquiry
                        </button> */}
                    </div>

                    {/* Refresh Button */}
                    <div className="d-flex align-items-center gap-2">
                        <button
                            type="button"
                            className="btn btn-primary btn-sm small"
                            onClick={async () => {
                                setPage(1);
                                setPaginationKeys([]);
                                setDisplayCount(INITIAL_DISPLAY);
                                setAll_last_key("");
                                setHasMore(true);
                                setHasInitialRecords(false);
                                setChatData([]);
                                setRefreshKey(prev => prev + 1); // Trigger AllChatHistory reset

                                // Load history and update hasInitialRecords based on result
                                const { hasRecords, nextKey } = await loadHistory("");

                                // If no records found on initial load, retry once
                                if (!hasRecords && nextKey) {
                                    const retryResult = await loadHistory(nextKey);

                                    if (!retryResult.hasRecords) {
                                        setHasInitialRecords(false);
                                        setHasMore(false);
                                    } else {
                                        setHasInitialRecords(true);
                                    }
                                } else if (hasRecords) {
                                    // Records found on first attempt
                                    setHasInitialRecords(true);
                                } else {
                                    // No records and no nextKey
                                    setHasInitialRecords(false);
                                    setHasMore(false);
                                }
                            }}
                        >
                            <i className="bi bi-arrow-clockwise me-1"></i>Refresh
                        </button>

                        {/* Filter Button - distinct color & position */}
                        <button
                            type="button"
                            className="btn btn-sm filter-chip-btn"
                            onClick={() => {
                                // Reset to default last week dates when opening modal
                                const defaultFilters = getDefaultFilters();
                                setTempFilters(defaultFilters);
                                setDateRange([getDefaultDateRange()]);
                                setIsInitialFilterApplied(false); // Reset flag when opening modal
                                setShowFilterModal(true);
                            }}
                        >
                            <i className="bi bi-funnel"></i>
                            Filter
                        </button>
                    </div>
                </div>
            </div>

            {/* Tab Content */}
            <div className="tab-content new-chat-tab-content" id="myTabContent">
                <div className={`tab-pane fade ${activeInnerTab === "allchat" ? "show active" : ""}`}>
                    {/* Chat List - Card Based Layout */}
                    <AllChatHistory key={`allchat-${refreshKey}`} setIsDirty={setIsDirty} isDirty={isDirty} tabType={activeInnerTab} chatData={chatData.slice(0, displayCount)} loading={loading} formatTimeAgo={formatTimeAgo} setPublishModal={setConfirmModal} />
                    {/* <AllChatHistory setIsDirty={setIsDirty} isDirty={isDirty} tabType={activeInnerTab} chatData={filteredChatData.slice(0, displayCount)} loading={loading} formatTimeAgo={formatTimeAgo} /> */}
                </div>
                <div className={`tab-pane fade ${activeInnerTab === "identified" ? "show active" : ""}`}>
                    {/* Chat List - Card Based Layout */}
                    <AllChatHistory key={`identified-${refreshKey}`} setIsDirty={setIsDirty} isDirty={isDirty} tabType={activeInnerTab} chatData={chatData.slice(0, displayCount)} loading={loading} formatTimeAgo={formatTimeAgo} setPublishModal={setConfirmModal} />
                    {/* <AllChatHistory setIsDirty={setIsDirty} isDirty={isDirty} tabType={activeInnerTab} chatData={filteredChatData.slice(0, displayCount)} loading={loading} formatTimeAgo={formatTimeAgo} /> */}
                </div>
                <div className={`tab-pane fade ${activeInnerTab === "anonymous" ? "show active" : ""}`}>
                    {/* Chat List - Card Based Layout */}
                    <AllChatHistory key={`anonymous-${refreshKey}`} setIsDirty={setIsDirty} isDirty={isDirty} tabType={activeInnerTab} chatData={chatData.slice(0, displayCount)} loading={loading} formatTimeAgo={formatTimeAgo} setPublishModal={setConfirmModal} />
                    {/* <AllChatHistory setIsDirty={setIsDirty} isDirty={isDirty} tabType={activeInnerTab} chatData={filteredChatData.slice(0, displayCount)} loading={loading} formatTimeAgo={formatTimeAgo} /> */}
                </div>
                <div className={`tab-pane fade ${activeInnerTab === "inquiry" ? "show active" : ""}`}>
                    {/* Chat List - Card Based Layout */}
                    <AllChatHistory key={`inquiry-${refreshKey}`} setIsDirty={setIsDirty} isDirty={isDirty} tabType={activeInnerTab} chatData={chatData.slice(0, displayCount)} loading={loading} formatTimeAgo={formatTimeAgo} setPublishModal={setConfirmModal} />
                    {/* <AllChatHistory setIsDirty={setIsDirty} isDirty={isDirty} tabType={activeInnerTab} chatData={filteredChatData.slice(0, displayCount)} loading={loading} formatTimeAgo={formatTimeAgo} /> */}
                </div>
            </div>

            {/* Load More/Less Buttons - Show only if there are more than 10 records */}
            {chatData.length > INITIAL_DISPLAY && (
                <div className="d-flex justify-content-center mt-3 mb-2">
                    {displayCount < chatData.length ? (
                        <button
                            type="button"
                            className="btn btn-outline-secondary btn-sm"
                            onClick={handleLoadMore}
                        >
                            Load More ({chatData.length - displayCount} more) <i className="bi bi-chevron-down me-1"></i>
                        </button>
                    ) : (
                        <button
                            type="button"
                            className="btn btn-outline-secondary btn-sm"
                            onClick={handleLoadLess}
                        >
                            Load Less (Show {INITIAL_DISPLAY}) <i className="bi bi-chevron-up me-1"></i>
                        </button>
                    )}
                </div>
            )}

            {hasInitialRecords || page > 1 ? (
                <nav aria-label="pagination" className="d-flex justify-content-between align-items-center mt-3">
                    <span>
                        Page <span className="fw-semibold small">{page}</span>
                        {chatData.length > 0 ? (
                            <span className="fw-semibold small text-muted"> (showing {displayCount} of {chatData.length} {chatData.length === 1 ? 'chat' : 'chats'})</span>
                        ) : (
                            <span className="fw-semibold small text-muted"> (no records found)</span>
                        )}
                        {!hasMore && (
                            <span className="fw-semibold small text-muted"> - end of results</span>
                        )}
                        {/* {searchText ? (
                        <span className="fw-semibold small text-muted"> (showing {Math.min(displayCount, filteredChatData.length)} of {filteredChatData.length} {filteredChatData.length === 1 ? 'match' : 'matches'} from {chatData.length} {chatData.length === 1 ? 'chat' : 'chats'})</span>
                    ) : (
                        <>
                            {chatData.length > 0 ? (
                                <span className="fw-semibold small text-muted"> (showing {displayCount} of {chatData.length} {chatData.length === 1 ? 'chat' : 'chats'})</span>
                            ) : (
                                <span className="fw-semibold small text-muted"> (no records found)</span>
                            )}
                        </>
                    )} */}
                    </span>

                    <ul className="pagination mb-0 align-items-center">
                        {/* Previous Button */}
                        <li className={`page-item me-2 ${page === 1 ? "disabled" : ""}`}>
                            <button
                                className="page-link"
                                onClick={handlePreviousPage}
                                disabled={page === 1 || loading}
                            >
                                <i className="bi bi-chevron-left"></i>
                            </button>
                        </li>

                        {/* Current Page Indicator */}
                        <li className="page-item active">
                            <span className="page-link">{page}</span>
                        </li>

                        {/* Next Button */}
                        <li className={`page-item ms-2 ${!hasMore ? "disabled" : ""}`}>
                            <button
                                className="page-link"
                                onClick={handleNextPage}
                                disabled={!hasMore || loading}
                            >
                                <i className="bi bi-chevron-right"></i>
                            </button>
                        </li>
                    </ul>
                </nav>
            ) : null}
            {/* Filter Modal */}
            <Modal
                show={showFilterModal}
                onHide={() => {
                    setShowFilterModal(false);
                    resetFilterModalState();
                }}
                size="lg"
                dialogClassName="filter-modal-top-center"
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Filter Chat History</Modal.Title>
                </Modal.Header>
                <Modal.Body className="py-0">
                    <div className="row mb-3 align-items-end pt-3 row-gap-2">
                        <div className="col-md-4">
                            <DateRangeSelector
                                value={dateRange}
                                small={true}
                                onSelect={({ from_date, to_date }) => {
                                    // If dates are cleared, use default last week range
                                    if (!from_date || !to_date) {
                                        const defaultRange = getDefaultDateRange();
                                        const defaultFilters = getDefaultFilters();
                                        setDateRange([defaultRange]);
                                        setTempFilters((prev) => ({
                                            ...prev,
                                            from_date: defaultFilters.from_date,
                                            to_date: defaultFilters.to_date,
                                        }));
                                    } else {
                                        const updatedRange = [
                                            {
                                                startDate: new Date(from_date),
                                                endDate: new Date(to_date),
                                                key: "selection",
                                            },
                                        ];
                                        setDateRange(updatedRange);
                                        setTempFilters((prev) => ({
                                            ...prev,
                                            from_date,
                                            to_date,
                                        }));
                                    }
                                }}
                            />
                        </div>

                        <div className="col-md-4">
                            <Form.Label className="fw-semibold">Status</Form.Label>
                            <Form.Select
                                className="form-control"
                                value={tempFilters.status}
                                onChange={(e) =>
                                    setTempFilters({ ...tempFilters, status: e.target.value })
                                }
                            >
                                <option value="">All</option>
                                <option value="success">Success</option>
                                <option value="failed">Failed</option>
                            </Form.Select>
                        </div>

                        <div className="col-md-4">
                            <Form.Label className="fw-semibold">Confidence</Form.Label>
                            <Form.Select
                                className="form-control"
                                value={tempFilters.confidence}
                                onChange={(e) =>
                                    setTempFilters({ ...tempFilters, confidence: e.target.value })
                                }
                            >
                                <option value="">All</option>
                                <option value="high">High</option>
                                <option value="medium">Medium</option>
                                <option value="low">Low</option>
                            </Form.Select>
                        </div>
                    </div>

                    {/* Reset and Apply Buttons */}
                    <div className="d-flex justify-content-end justify-content-sm-between align-items-center mb-3 flex-wrap gap-2">
                        <div className="d-flex gap-2">
                            <Button
                                type="button"
                                variant="secondary"
                                size="sm"
                                onClick={handleResetFilters}
                                disabled={filterLoading}
                            >
                                Reset
                            </Button>
                            <Button
                                type="button"
                                variant="primary"
                                size="sm"
                                onClick={handleFilterSearch}
                                disabled={filterLoading}
                            >
                                Apply
                            </Button>

                        </div>
                        {showFilteredTable && (
                            <div className="search-wrapper">
                                <input
                                    type="text"
                                    className="mandatory-search-input rounded w-100"
                                    placeholder="Search by question..."
                                    value={searchText}
                                    onChange={(e) => setSearchText(e.target.value)}
                                />
                                <i className="bi bi-search search-icon"></i>
                            </div>
                        )}
                    </div>
                    {/* Loading Spinner - Show when loading, regardless of showFilteredTable state */}
                    {filterLoading && (
                        <div className="text-center py-4">
                            <div className="spinner-border spinner-border-sm" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    )}

                    {/* Filtered Table View inside Modal */}
                    {showFilteredTable && !filterLoading && (
                        <>
                            {/* Search Input - same style as FAQ/ChatHistory search */}

                            <div className="table-responsive mb-3">
                                <table className="table chat-table table-sm mb-0">
                                    <thead className="thead-dark sticky-top">
                                        <tr>
                                            <th
                                                style={{ width: "200px", cursor: "pointer" }}
                                                onClick={() => handleSort('question')}
                                            >
                                                Question <span className="text-muted">{getSortIcon('question')}</span>
                                            </th>
                                            <th
                                                style={{ cursor: "pointer", width: "100px" }}
                                                onClick={() => handleSort('status_type')}
                                            >
                                                Status <span className="text-muted">{getSortIcon('status_type')}</span>
                                            </th>
                                            <th
                                                style={{ cursor: "pointer", width: "100px" }}
                                                onClick={() => handleSort('confidence')}
                                            >
                                                AI Score <span className="text-muted">{getSortIcon('confidence')}</span>
                                            </th>
                                            <th
                                                style={{ width: "240px", cursor: "pointer" }}
                                                onClick={() => handleSort('msg_time')}
                                            >
                                                Date & Time <span className="text-muted">{getSortIcon('msg_time')}</span>
                                            </th>
                                            <th style={{ width: "150px", textAlign: "center" }}>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentRecords.length === 0 ? (
                                            <tr>
                                                <td colSpan={5} className="text-center text-muted py-3">
                                                    No filtered chat history found.
                                                </td>
                                            </tr>
                                        ) : (
                                            currentRecords.map((item, index) => (
                                                <tr
                                                    key={index}
                                                    className="align-middle"
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => handleRowClick(item)}
                                                >
                                                    <td>{truncateText(item.question, 25)}</td>
                                                    <td>
                                                        {item.status_type === "success" ? (
                                                            <i className="bi bi-hand-thumbs-up-fill thumsup-text-success fs-5"></i>
                                                        ) : (
                                                            <i className="bi bi-hand-thumbs-down-fill thumsdown-text-danger fs-5"></i>
                                                        )}
                                                    </td>
                                                    <td>
                                                        {item.confidence === "high" ? (
                                                            <i className="bi bi-hand-thumbs-up-fill thumsup-text-success fs-5"></i>
                                                        ) : item.confidence === "medium" ? (
                                                            <i className="bi bi-hand-thumbs-down-fill text-warning fs-5"></i>
                                                        ) : item.confidence === "low" ? (
                                                            <i className="bi bi-hand-thumbs-down-fill thumsdown-text-danger fs-5"></i>
                                                        ) : (
                                                            ""
                                                        )}
                                                    </td>
                                                    <td>{item.msg_time ? formatCustomDate(item.msg_time) : '-'}</td>
                                                    <td className="col-auto" onClick={(e) => e.stopPropagation()}>
                                                        <div className="icon-container justify-content-center">
                                                            <OverlayTrigger
                                                                placement="top"
                                                                delay={{ show: 250, hide: 400 }}
                                                                overlay={
                                                                    <Tooltip id={`tooltip-view-${index}`}>
                                                                        View conversation
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <img
                                                                    src={viewdetailicon}
                                                                    alt="View"
                                                                    className="action-icon"
                                                                    onClick={() => handleRowClick(item)}
                                                                />
                                                            </OverlayTrigger>
                                                            <OverlayTrigger
                                                                placement="top"
                                                                delay={{ show: 250, hide: 400 }}
                                                                overlay={
                                                                    <Tooltip id={`tooltip-teach-${index}`}>
                                                                        Teach me
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <img
                                                                    src={teachicon}
                                                                    alt="Teach me"
                                                                    className="action-icon"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        handleAddFaq(item);
                                                                    }}
                                                                />
                                                            </OverlayTrigger>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            {/* Show pagination section only when there is data */}
                            {sortedData.length > 0 && (
                                <div className="chat-table-pagination d-flex justify-content-between align-items-center gap-3 flex-wrap mb-2">
                                    <div className="d-flex align-items-center gap-2">
                                        <label className="mb-0">Rows per page:</label>
                                        <Form.Select
                                            value={pageSize}
                                            onChange={(e) => {
                                                setPageSize(Number(e.target.value));
                                                setCurrentPage(1);
                                            }}
                                            className="rounded px-2 py-1 chat-table-page-size-select"
                                        >
                                            <option value="5">5</option>
                                            <option value="10">10</option>
                                            <option value="20">20</option>
                                        </Form.Select>
                                    </div>

                                    {/* Show pagination buttons only if there's more than one page */}
                                    {totalPages > 1 && (
                                        <div className="d-flex align-items-center gap-2 ms-auto">
                                            <button
                                                type="button"
                                                className="btn btn-secondary btn-sm chat-table-page-btn"
                                                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                                                disabled={currentPage === 1}
                                            >
                                                <i className="bi bi-chevron-left"></i>
                                            </button>
                                            <span className="fw-semibold chat-table-page-info">
                                                Page {currentPage} of {totalPages}
                                            </span>
                                            <button
                                                type="button"
                                                className="btn btn-secondary btn-sm chat-table-page-btn"
                                                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                                                disabled={currentPage === totalPages}
                                            >
                                                <i className="bi bi-chevron-right"></i>
                                            </button>
                                        </div>
                                    )}
                                </div>
                            )}
                        </>
                    )}
                </Modal.Body>
            </Modal>

            {/* Chat Details Modal */}
            <Modal show={showDetailModal} onHide={() => setShowDetailModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Chat Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedChatItem && (
                        <>
                            <p><strong>Question : </strong> {selectedChatItem.question}</p>
                            <p><strong>Answer : </strong> {selectedChatItem.answer}</p>
                            <p><strong>Status : </strong> {selectedChatItem.status_type}</p>
                            <p><strong>AI Confidence : </strong> {selectedChatItem.confidence}</p>
                            <p><strong>Time : </strong> {selectedChatItem.msg_time ? new Date(selectedChatItem.msg_time).toLocaleString() : '-'}</p>
                            {selectedChatItem.customer_name && (
                                <p><strong>Customer Name : </strong>  {selectedChatItem.customer_name}</p>
                            )}
                            {selectedChatItem.customer_email && (
                                <p><strong>Customer Email : </strong>  {selectedChatItem.customer_email}</p>
                            )}
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDetailModal(false)}>Close</Button>
                </Modal.Footer>
            </Modal>

            {/* QnA Modal */}
            <QnAModal
                setIsDirty={setIsDirty}
                show={showQnaModal}
                onHide={() => {
                    setQnaError("");
                    setShowQnaModal(false);
                    setIsDirty(false);
                }}
                mode="add"
                draft={newQuestionDraft}
                setDraft={setNewQuestionDraft}
                onSubmit={handleFAQSave}
                errorMsg={qnaError}
                setErrorMsg={setQnaError}
                loading={modalLoading}
                isDirty={isDirty}
                setPublishModal={setConfirmModal}
            />
        </>
    );
};

export default NewChatHistory;
